import React from "react";

export const Copyright = () => {
    return (
        <p className="mt-5 mb-3 text-muted">&copy; 2020 - Lotus Moonlight</p>
    )
}